import { motion } from 'framer-motion'
import styles from './About.module.css'

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.08,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
}

const About = () => {
  return (
    <motion.div
      className={styles.layout}
      variants={containerVariants}
      initial='hidden'
      animate='show'
    >
      <motion.h1
        className={styles.pageTitle}
        variants={itemVariants}
      >
        About
      </motion.h1>

      <div className={styles.aboutView}>
        <motion.div
          className={styles.aboutDetails}
          variants={containerVariants}
        >
          <div className={styles.bioWrapper}>
            <motion.p
              className={styles.bioIntro}
              variants={itemVariants}
            >
              <b>Piotr Opala</b> is a Berlin-based pianist and composer known
              for creating melancholic, dreamlike piano music and evocative
              soundscapes. Blending delicate melodies with atmospheric textures,
              his work invites listeners into a world of quiet introspection and
              beauty.
            </motion.p>

            <motion.p
              className={styles.bioParagraph}
              variants={itemVariants}
            >
              Born in Poznań, Poland in 1992, Piotr grew up surrounded by music
              and began learning the piano at the age of seven. Throughout his
              education, he performed regularly, appearing in various
              productions, including a performance at the Grand Theatre in
              Poznań.
            </motion.p>

            <motion.p
              className={styles.bioParagraph}
              variants={itemVariants}
            >
              After moving to Germany, Piotr stepped away from music for several
              years. He returned in 2024 with his debut EP <em>Somnium</em>,
              followed by <em>Caligo</em> in 2025, further shaping his distinct
              sonic identity.
            </motion.p>

            <motion.p
              className={styles.bioParagraph}
              variants={itemVariants}
            >
              Alongside his releases, he has contributed to a range of artistic
              projects and continues to perform in intimate and spontaneous
              settings.
            </motion.p>
          </div>
        </motion.div>

        <motion.img
          className={styles.cover}
          src='/Images/piotrOpala.jpg'
          alt='Piotr Opala'
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
        />
      </div>
    </motion.div>
  )
}

export default About
